var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "user-center-slot",
    [
      _c(
        "user-center-container-slot",
        [
          _c("user-center-menu"),
          _vm._v(" "),
          _c(
            "user-center-content-slot",
            [
              _c("user-center-content-title", { attrs: { title: "团队菜单" } }),
              _vm._v(" "),
              _c("div", { staticClass: "user-center__team-row" }, [
                _c("div", { staticClass: "user-center__team-portrait" }, [
                  _c("div", [
                    _vm.pictureID
                      ? _c("img", {
                          staticClass: "user-center__team-pic",
                          attrs: { src: _vm.pictureID }
                        })
                      : _c("i", {
                          staticClass:
                            "iconfont icon-tuandui user-center__team-icon--default"
                        })
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "user-center__team-summary--left" },
                    [
                      !_vm.noTeam && !_vm.isTeamLeader
                        ? _c(
                            "span",
                            { staticClass: "user-center__team-summary-txt" },
                            [
                              _vm._v("\n                            您加入了 "),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "user-center__team-summary-txt--inner"
                                },
                                [_vm._v(_vm._s(_vm.teamUserInfo.teamName))]
                              ),
                              _vm._v("战队\n                        ")
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.noTeam && !_vm.isTeamLeader
                        ? _c(
                            "span",
                            { staticClass: "user-center__team-summary-txt" },
                            [
                              _vm._v(
                                "\n                            您还未加入任何队伍\n                        "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isTeamLeader
                        ? _c(
                            "span",
                            { staticClass: "user-center__team-summary-txt" },
                            [
                              _vm._v("\n                            您是"),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "user-center__team-summary-txt--inner"
                                },
                                [_vm._v(_vm._s(_vm.teamUserInfo.teamName))]
                              ),
                              _vm._v("队长\n                        ")
                            ]
                          )
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _vm.isTeamLeader
                    ? _c(
                        "div",
                        { staticClass: "user-center__team-summary--right" },
                        [
                          _vm._v("\n                        贡献值："),
                          _c(
                            "span",
                            {
                              staticClass:
                                "user-center__team-summary-txt--inner user-center__team-summary-txt--contributed"
                            },
                            [_vm._v(_vm._s(_vm.teamUserInfo.donate))]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.noTeam && !_vm.isTeamLeader
                    ? _c(
                        "div",
                        { staticClass: "user-center__team-summary--right" },
                        [
                          _vm._v("\n                        贡献值："),
                          _c(
                            "span",
                            {
                              staticClass:
                                "user-center__team-summary-txt--inner user-center__team-summary-txt--contributed"
                            },
                            [_vm._v(_vm._s(_vm.teamUserInfo.donate))]
                          )
                        ]
                      )
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "user-center__team-row--secondary" }, [
                _c("span", [_vm._v("团队信息")])
              ]),
              _vm._v(" "),
              _vm.noTeam && !_vm.isTeamLeader
                ? _c("div", { staticClass: "user-center__team-operation" }, [
                    _c(
                      "a",
                      {
                        staticClass: "user-center__team-operation-button",
                        attrs: { href: "javascript:void(0);" },
                        on: { click: _vm.openCreateTeam }
                      },
                      [_vm._v("创建团队")]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "user-center__team-operation-button",
                        attrs: { href: "javascript:void(0);" },
                        on: { click: _vm.openJoinTeam }
                      },
                      [_vm._v("加入团队")]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "user-center__team-list" },
                [
                  _c(
                    "xui-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.tableLoading,
                          expression: "tableLoading"
                        }
                      ],
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.latestData,
                        stripe: false,
                        "show-header": true
                      }
                    },
                    [
                      _c("xui-table-column", {
                        attrs: {
                          prop: "teamName",
                          "show-overflow-tooltip": "",
                          label: "团队名称",
                          align: "left"
                        }
                      }),
                      _vm._v(" "),
                      _c("xui-table-column", {
                        attrs: {
                          prop: "teamUser",
                          "show-overflow-tooltip": "",
                          label: "用户昵称"
                        }
                      }),
                      _vm._v(" "),
                      _c("xui-table-column", {
                        attrs: {
                          prop: "donate",
                          "show-overflow-tooltip": "",
                          width: "100",
                          label: "贡献值"
                        }
                      }),
                      _vm._v(" "),
                      _c("xui-table-column", {
                        attrs: { label: "操作" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _vm.isTeamLeader &&
                                !(
                                  _vm.teamUserInfo.teamUser ===
                                  scope.row.teamUser
                                )
                                  ? _c(
                                      "xui-button",
                                      {
                                        attrs: { type: "text" },
                                        on: {
                                          click: function($event) {
                                            return _vm.operations(
                                              scope.row,
                                              "handOver"
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v("转让队长")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.isTeamLeader &&
                                !(
                                  _vm.teamUserInfo.teamUser ===
                                  scope.row.teamUser
                                )
                                  ? _c(
                                      "xui-button",
                                      {
                                        attrs: { type: "text" },
                                        on: {
                                          click: function($event) {
                                            return _vm.operations(
                                              scope.row,
                                              "kickOut"
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v("踢出成员")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.isTeamLeader &&
                                _vm.teamUserInfo.teamUser === scope.row.teamUser
                                  ? _c(
                                      "xui-button",
                                      {
                                        attrs: { type: "text" },
                                        on: {
                                          click: function($event) {
                                            return _vm.operations(
                                              scope.row,
                                              "quit"
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v("退出团队")]
                                    )
                                  : _vm._e()
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "user-center__team-row--secondary" }, [
                _c("span", [_vm._v("我的消息")])
              ]),
              _vm._v(" "),
              !_vm.isTeamLeader && _vm.msgList.length
                ? _c(
                    "div",
                    _vm._l(_vm.msgList, function(item, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "user-center__person-msg-list"
                        },
                        [
                          !item.isAdmin && !item.status
                            ? _c(
                                "div",
                                { staticClass: "user-center__person-msg-item" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "user-center__person-msg-txt--top"
                                    },
                                    [
                                      _c("div", [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "user-center__person-msg-tag"
                                          },
                                          [_vm._v("系统通知")]
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "user-center__person-team-type"
                                          },
                                          [_vm._v("对战队")]
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "user-center__person-team-name"
                                          },
                                          [_vm._v(_vm._s(item.teamName))]
                                        ),
                                        _vm._v(" "),
                                        item.type === 1
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "user-center__person-team-name",
                                                staticStyle: {
                                                  "padding-left": "15px"
                                                }
                                              },
                                              [_vm._v("申请加入")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        item.type === 2
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "user-center__person-team-name",
                                                staticStyle: {
                                                  "padding-left": "15px"
                                                }
                                              },
                                              [_vm._v("申请退出")]
                                            )
                                          : _vm._e()
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "user-center__person-approval"
                                        },
                                        [_vm._v("申请已提交，等待团长审核")]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "user-center__person-msg-txt--middle"
                                    },
                                    [
                                      _vm._v(
                                        "\n                            申请内容：\n                            "
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "user-center__person-application"
                                        },
                                        [_vm._v(_vm._s(item.content))]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "user-center__person-msg-txt--bottom"
                                    },
                                    [_vm._v(_vm._s(item.creationDate))]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          item.isAdmin && !item.status
                            ? _c(
                                "div",
                                { staticClass: "user-center__person-msg-item" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "user-center__person-msg-txt--top"
                                    },
                                    [
                                      _c("div", [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "user-center__person-msg-tag"
                                          },
                                          [_vm._v("系统通知")]
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "user-center__person-team-type"
                                          },
                                          [_vm._v("对战队")]
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "user-center__person-team-name"
                                          },
                                          [_vm._v(_vm._s(item.teamName))]
                                        ),
                                        _vm._v(" "),
                                        item.type === 1
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "user-center__person-team-name",
                                                staticStyle: {
                                                  "padding-left": "15px"
                                                }
                                              },
                                              [_vm._v("申请加入")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        item.type === 2
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "user-center__person-team-name",
                                                staticStyle: {
                                                  "padding-left": "15px"
                                                }
                                              },
                                              [_vm._v("申请退出")]
                                            )
                                          : _vm._e()
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "user-center__person-approval"
                                        },
                                        [_vm._v("申请团长已同意")]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "user-center__person-msg-txt--bottom"
                                    },
                                    [_vm._v(_vm._s(item.creationDate))]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          item.isAdmin && item.status
                            ? _c(
                                "div",
                                { staticClass: "user-center__person-msg-item" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "user-center__person-msg-txt--top"
                                    },
                                    [
                                      _c("div", [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "user-center__person-msg-tag"
                                          },
                                          [_vm._v("系统通知")]
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "user-center__person-team-type"
                                          },
                                          [_vm._v("对战队")]
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "user-center__person-team-name"
                                          },
                                          [_vm._v(_vm._s(item.teamName))]
                                        ),
                                        _vm._v(" "),
                                        item.type === 1
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "user-center__person-team-name",
                                                staticStyle: {
                                                  "padding-left": "15px"
                                                }
                                              },
                                              [_vm._v("申请加入")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        item.type === 2
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "user-center__person-team-name",
                                                staticStyle: {
                                                  "padding-left": "15px"
                                                }
                                              },
                                              [_vm._v("申请退出")]
                                            )
                                          : _vm._e()
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "user-center__person-approval"
                                        },
                                        [_vm._v("申请团长已拒绝")]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "user-center__person-msg-txt--bottom"
                                    },
                                    [_vm._v(_vm._s(item.creationDate))]
                                  )
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isTeamLeader && _vm.msgList.length
                ? _c(
                    "div",
                    _vm._l(_vm.msgList, function(item, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "user-center__person-msg-list"
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "user-center__person-msg-item" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "user-center__person-msg-txt--top"
                                },
                                [
                                  item.type === 1
                                    ? _c("div", [
                                        _vm._v(
                                          _vm._s(item.teamUser) +
                                            "于" +
                                            _vm._s(item.creationDate) +
                                            "向您提交战队申请"
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.type === 2
                                    ? _c("div", [
                                        _vm._v(
                                          _vm._s(item.teamUser) +
                                            "于" +
                                            _vm._s(item.creationDate) +
                                            "向您提交退出战队申请"
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.type === 1
                                    ? _c("div", [
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "user-center__person-approval-button",
                                            attrs: {
                                              href: "javascript: void(0);"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.approve(item, "y")
                                              }
                                            }
                                          },
                                          [_vm._v("同意")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "user-center__person-approval-button",
                                            attrs: {
                                              href: "javascript: void(0);"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.approve(item, "n")
                                              }
                                            }
                                          },
                                          [_vm._v("拒绝")]
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.type === 2
                                    ? _c("div", [
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "user-center__person-approval-button",
                                            attrs: {
                                              href: "javascript: void(0);"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.approveQuit(
                                                  item,
                                                  "y"
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v("同意")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "user-center__person-approval-button",
                                            attrs: {
                                              href: "javascript: void(0);"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.approveQuit(
                                                  item,
                                                  "n"
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v("拒绝")]
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "user-center__person-msg-txt--middle"
                                },
                                [
                                  _vm._v(
                                    "\n                            申请内容：\n                            "
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "user-center__person-application"
                                    },
                                    [_vm._v(_vm._s(item.content))]
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "user-center__team-pager" },
                [
                  _c("xui-pagination", {
                    attrs: {
                      "current-page": _vm.page.currentPage,
                      "page-sizes": _vm.page.pageSizes,
                      "page-size": _vm.page.pageSize,
                      total: _vm.page.totalPages,
                      layout: "total, sizes, pager, jumper"
                    },
                    on: {
                      "update:currentPage": function($event) {
                        return _vm.$set(_vm.page, "currentPage", $event)
                      },
                      "update:current-page": function($event) {
                        return _vm.$set(_vm.page, "currentPage", $event)
                      },
                      "size-change": _vm.handleSizeChange,
                      "current-change": _vm.handleCurrentChange1
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.joinTeam
        ? _c(
            "xui-dialog",
            {
              staticClass: "joinTeamDialog",
              attrs: {
                title: "加入团队",
                "close-on-click-modal": false,
                showcenter: "",
                visible: _vm.joinTeam,
                width: "30%"
              },
              on: {
                "update:visible": function($event) {
                  _vm.joinTeam = $event
                },
                close: function($event) {
                  _vm.joinTeam = false
                }
              }
            },
            [
              _c(
                "div",
                { staticStyle: { "font-size": "1rem", color: "#aaaab3" } },
                [
                  _vm._v(
                    "温馨提示每个用户最多可同时申报3个战队，最先通过加入成功，加入满三个月后可退出"
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "xui-form",
                {
                  ref: "joinTeamForm",
                  staticStyle: { padding: "0 20px", "margin-top": "25px" },
                  attrs: {
                    "label-width": "80px",
                    "inline-message": true,
                    "label-position": "top",
                    rules: _vm.rules,
                    model: _vm.commit,
                    cols: 4
                  }
                },
                [
                  _c(
                    "xui-form-group",
                    [
                      _c(
                        "xui-form-item",
                        {
                          attrs: {
                            label: "申请战队名称",
                            cols: 4,
                            prop: "applyName"
                          }
                        },
                        [
                          _c(
                            "xui-select",
                            {
                              staticClass: "xui-select-class-0",
                              attrs: {
                                placeholder: "请选择",
                                "popper-class": "xui-select-popper",
                                clearable: ""
                              },
                              on: { change: _vm.changeTemplate },
                              model: {
                                value: _vm.commit.applyName,
                                callback: function($$v) {
                                  _vm.$set(_vm.commit, "applyName", $$v)
                                },
                                expression: "commit.applyName"
                              }
                            },
                            _vm._l(_vm.options1, function(item) {
                              return _c("xui-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "xui-form-group",
                    [
                      _c(
                        "xui-form-item",
                        {
                          attrs: {
                            label: "申请内容",
                            cols: 4,
                            prop: "applyMember"
                          }
                        },
                        [
                          _c("xui-input", {
                            attrs: {
                              clearable: "",
                              rows: 5,
                              type: "textarea",
                              maxlength: 300
                            },
                            model: {
                              value: _vm.commit.applyMember,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.commit,
                                  "applyMember",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "commit.applyMember"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer", center: "" },
                  slot: "footer"
                },
                [
                  _c(
                    "xui-button",
                    {
                      attrs: { type: "primary", size: "bigger" },
                      on: {
                        click: function($event) {
                          _vm.joinTeam = false
                        }
                      }
                    },
                    [_vm._v(" 取消")]
                  ),
                  _vm._v(" "),
                  _c(
                    "xui-button",
                    {
                      attrs: { type: "primary", size: "bigger" },
                      on: {
                        click: function($event) {
                          return _vm.commitVerify("add")
                        }
                      }
                    },
                    [_vm._v("提交审核")]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.quitTeam
        ? _c(
            "xui-dialog",
            {
              staticClass: "joinTeamDialog",
              attrs: {
                title: "退出团队",
                "close-on-click-modal": false,
                showcenter: "",
                visible: _vm.quitTeam,
                width: "30%"
              },
              on: {
                "update:visible": function($event) {
                  _vm.quitTeam = $event
                },
                close: function($event) {
                  _vm.quitTeam = false
                  _vm.closeQuit()
                }
              }
            },
            [
              _c(
                "xui-form",
                {
                  ref: "leaveTeamForm",
                  staticStyle: { padding: "0 20px", "margin-top": "25px" },
                  attrs: {
                    "label-width": "80px",
                    "inline-message": true,
                    "label-position": "top",
                    rules: _vm.rules,
                    model: _vm.commit,
                    cols: 4
                  }
                },
                [
                  _c(
                    "xui-form-group",
                    [
                      _c(
                        "xui-form-item",
                        {
                          attrs: { label: "退出原因", cols: 4, prop: "content" }
                        },
                        [
                          _c("xui-input", {
                            attrs: {
                              clearable: "",
                              rows: 5,
                              type: "textarea",
                              maxlength: 300,
                              placeholder: "请输入退出原因"
                            },
                            model: {
                              value: _vm.commit.content,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.commit,
                                  "content",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "commit.content"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer", center: "" },
                  slot: "footer"
                },
                [
                  _c(
                    "xui-button",
                    {
                      attrs: { type: "primary", size: "bigger" },
                      on: {
                        click: function($event) {
                          _vm.quitTeam = false
                          _vm.closeQuit()
                        }
                      }
                    },
                    [_vm._v("\n                取消")]
                  ),
                  _vm._v(" "),
                  _c(
                    "xui-button",
                    {
                      attrs: { type: "primary", size: "bigger" },
                      on: {
                        click: function($event) {
                          return _vm.commitQuitOpine()
                        }
                      }
                    },
                    [_vm._v("提交审核")]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.createTeam
        ? _c(
            "xui-dialog",
            {
              staticClass: "joinTeamDialog",
              attrs: {
                title: "创建团队",
                "close-on-click-modal": false,
                showcenter: "",
                visible: _vm.createTeam,
                width: "30%"
              },
              on: {
                "update:visible": function($event) {
                  _vm.createTeam = $event
                },
                close: function($event) {
                  _vm.createTeam = false
                }
              }
            },
            [
              _c(
                "xui-form",
                {
                  ref: "createTeamForm",
                  staticStyle: { padding: "0 20px" },
                  attrs: {
                    "label-width": "80px",
                    "label-position": "top",
                    "inline-message": true,
                    rules: _vm.rules,
                    model: _vm.commit,
                    cols: 4
                  }
                },
                [
                  _c(
                    "xui-form-group",
                    [
                      _c(
                        "xui-form-item",
                        {
                          staticClass: "test",
                          staticStyle: {
                            "margin-left": "33%",
                            "margin-bottom": "30px",
                            height: "171px"
                          },
                          attrs: { prop: "headPictureUrl", cols: 2 }
                        },
                        [
                          _c("div", { staticClass: "user-setting-avatar" }, [
                            _c("div", [
                              _c("div", { staticClass: "user-info-pic" }, [
                                _c(
                                  "div",
                                  { staticClass: "avatar-uploader" },
                                  [
                                    _c(
                                      "xui-upload",
                                      {
                                        staticClass: "xui-upload--text",
                                        staticStyle: { "text-align": "center" },
                                        attrs: {
                                          action: _vm.action,
                                          headers: _vm.xCsrfToken,
                                          "on-error": _vm.reportError,
                                          limit: 1,
                                          "before-upload": _vm.beforUploadZip,
                                          "show-overflow-tooltip": "",
                                          "on-exceed": _vm.handleExceed,
                                          "on-success": _vm.handlePreview,
                                          "with-credentials": true
                                        }
                                      },
                                      [
                                        _vm.commit.headPictureUrl
                                          ? [
                                              _c("img", {
                                                staticStyle: {
                                                  width: "150px",
                                                  height: "150px"
                                                },
                                                attrs: {
                                                  src:
                                                    this.$baseURL +
                                                    "vul/hsrc/vul/report/servlet/res/image?attachmentId=" +
                                                    _vm.commit.headPictureUrl
                                                }
                                              })
                                            ]
                                          : [
                                              _c("img", {
                                                staticStyle: {
                                                  width: "150px",
                                                  height: "150px"
                                                },
                                                attrs: {
                                                  src: require("../../../images/default-portrait.png")
                                                }
                                              })
                                            ],
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "upload-headPicture-btn"
                                          },
                                          [_vm._v("上传头像")]
                                        ),
                                        _vm._v(" "),
                                        _c("input", {
                                          staticClass: "xui-upload__input",
                                          attrs: {
                                            type: "file",
                                            name: "upload"
                                          }
                                        })
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                              ])
                            ])
                          ])
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "user-operations" }, [
                    _c("span", [
                      _vm._v("支持jpg、png、gif、jpeg格式图片，大小不超过2M")
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "xui-form-group",
                    [
                      _c(
                        "xui-form-item",
                        { attrs: { label: "战队名称", prop: "name", cols: 2 } },
                        [
                          _c("xui-input", {
                            attrs: { maxlength: 20 },
                            model: {
                              value: _vm.commit.name,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.commit,
                                  "name",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "commit.name"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer", center: "" },
                  slot: "footer"
                },
                [
                  _c(
                    "xui-button",
                    {
                      attrs: { type: "primary", size: "bigger" },
                      on: {
                        click: function($event) {
                          _vm.createTeam = false
                        }
                      }
                    },
                    [_vm._v(" 取消")]
                  ),
                  _vm._v(" "),
                  _c(
                    "xui-button",
                    {
                      attrs: { type: "primary", size: "bigger" },
                      on: {
                        click: function($event) {
                          return _vm.commitVerify("create")
                        }
                      }
                    },
                    [_vm._v("确认创建")]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "xui-dialog",
        {
          staticClass: "warnning-wrap",
          attrs: {
            title: "",
            "close-on-click-modal": false,
            showcenter: "",
            visible: _vm.dialogVisible,
            width: _vm.$store.state.isMobile ? "80%" : "30%",
            "before-close": _vm.handleClose
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c(
            "h3",
            {
              style: {
                "font-size": _vm.$store.state.isMobile ? "24px" : "16.5px"
              }
            },
            [_vm._v("荣耀安全应急响应中心服务条款")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "content-wrap",
              style: {
                "font-size": _vm.$store.state.isMobile ? "22px" : "14px"
              }
            },
            [
              _c("p", [
                _vm._v(
                  "欢迎您使用荣耀安全应急响应中心（Honor Security Response Center）服务，本平台在特定场景下需收集您的如下信息:"
                )
              ]),
              _vm._v(" "),
              _c("ul", [
                _c("li", [_vm._v("真实姓名，身份证正反面照片及身份证号；")]),
                _vm._v(" "),
                _c("li", [_vm._v("银行卡号，开户行信息，银行名称；")]),
                _vm._v(" "),
                _c("li", [_vm._v("手机号码，邮寄地址；")]),
                _vm._v(" "),
                _c("li", [_vm._v("昵称，头像，邮箱，主页；")]),
                _vm._v(" "),
                _c("li", [_vm._v("QQ，微信，签名，团队；")]),
                _vm._v(" "),
                _c("li", [_vm._v("IP地址；")]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "为防止欺骗行为，荣耀需采集浏览器信息（类型、时区、插件、语言、字体、canvas图片渲染哈希值、webgl图片渲染哈希值）；"
                  )
                ])
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "上述数据将会传输并保存至位于中华人民共和国境内的服务器。"
                )
              ]),
              _vm._v(" "),
              _c("span", [
                _vm._v("点击“同意”，即表示您同意\n                "),
                _c(
                  "a",
                  {
                    staticClass: "honor-security-user-protocol",
                    attrs: { href: _vm.safetyURL, target: "_blank" }
                  },
                  [_vm._v("荣耀安全应急响应中心用户协议")]
                ),
                _vm._v("\n                ，并知悉\n                "),
                _c(
                  "a",
                  {
                    staticClass: "honor-security-secret-statement",
                    attrs: { href: _vm.privacyURL, target: "_blank" }
                  },
                  [_vm._v("关于安全应急响应中心与隐私的声明")]
                ),
                _vm._v("。")
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "span",
            { attrs: { slot: "footer", center: "" }, slot: "footer" },
            [
              _c(
                "xui-button",
                { attrs: { size: "bigger" }, on: { click: _vm.handleClose } },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "xui-button",
                {
                  attrs: { type: "primary", size: "bigger" },
                  on: { click: _vm.confirm }
                },
                [_vm._v("同意")]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("login", {
        attrs: { isNotLogin: _vm.isNotLogin, isEffect: _vm.isEffect }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-31514228", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31514228","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/usercenter/teamMenu/teamMenuInfo.vue
// module id = null
// module chunks = 